import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import API from '@/apiRequest';
import CardList from '@/components/common/CardList';
import Spinner from '@/components/common/Spinner';
import UserCard from '@/components/FranchiseeSettingsPage/UserList/UserCard';
import { setOptions, setQuery } from '@/store/ducks/filter';
import { showToast } from '@/store/ducks/toasts';

const UserList = () => {
  const isInitialMount = useRef(true);
  const [cards, setCards] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const dispatch = useDispatch();

  const { query, lastReload } = useSelector(state => ({
    query: state.filter.query,
    lastReload: state.cards.lastReload,
  }));

  const fetchCards = useCallback(
    async filterText => {
      try {
        setIsLoading(true);
        const { data } = await API.get('/users', {
          params: {
            search: filterText || undefined,
          },
        });

        setCards(data.map(item => ({ data: item })));
        setIsLoading(false);
      } catch (err) {
        dispatch(
          showToast({
            type: 'error',
            title: intl.formatMessage({ id: 'ERROR' }),
            text: intl.formatMessage({ id: 'USER_LOAD_LIST_ERROR' }),
            duration: 3000,
          })
        );
        setIsLoading(false);
      }
    },
    [dispatch, intl]
  );

  useEffect(() => {
    dispatch(setOptions({ basic: ['text'] }));

    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (isInitialMount.current) {
      setQuery({});
      isInitialMount.current = false;
    } else {
      fetchCards(query.text);
    }
  }, [lastReload]);

  useEffect(() => {
    if (isInitialMount.current) {
      return;
    }

    if (Object.entries(query).length > 0) {
      const targetPath = location.pathname.includes('/commercial') ? '/commercial/settings/users' : '/settings/users';

      if (location.pathname !== targetPath) {
        navigate(targetPath);
      }
    }

    fetchCards(query.text);
  }, [query]);

  const loadMore = useCallback(() => {}, []);

  if (isLoading) {
    return (
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <Spinner />
      </div>
    );
  }

  return <CardList cards={cards} Element={UserCard} loadMore={loadMore} />;
};

export default UserList;
